import { createSlot } from '@ayocore/platform/client/extensions/createSlot';
import type { BulkActionSelection } from '@ayocore/platform/client/components/RepositoryTable/RepositoryTable';
import type { Deal } from '@ayocore/erp/crm/schemas/deal.schema';

/** Описание bulk-действия для списка сделок */
export interface DealBulkAction {
  title: string;
  handler: (selection: BulkActionSelection<Deal>) => void;
  color?: string;
  icon?: React.ReactNode;
}

/**
 * Точки расширения DealsList.
 *
 * Позволяют клиентским модулям добавлять bulk-действия
 * в список сделок без изменения базового кода CRM.
 *
 * @example
 * // src/modules/grasias/client/bootstrap.ts
 * import { DealListExtensions } from '@ayocore/erp/crm/client/components/Deals/DealListExtensions';
 *
 * DealListExtensions.bulkActions.register(() => ({
 *   title: 'Опись документов',
 *   handler: ({ ids }) => { ... },
 *   icon: <IconFileSpreadsheet size={14} />,
 * }));
 */
export const DealListExtensions = {
  /** Дополнительные bulk-действия (добавляются после базовых) */
  bulkActions: createSlot<void, DealBulkAction | null>(),
};
